import React, { Fragment, useState, useEffect } from 'react';
import { Card, Col, Container, Row, Button, CardBody, Table, ButtonGroup, Badge, Input } from 'reactstrap';
import { useCompanies } from '../../../hooks/companies/useCompanies';
import { CompaniesList } from '../../../constant';
import { ModalCompany } from '../../../components/companies/ModalCompany';
import { ModalSendEmail } from '../../../components/companies/ModalSendEmail';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DialogImgMicrositeCompany } from './DialogImgMicrositeCompany';
import { Dialog } from 'primereact/dialog';


export const IndexCompanies = () => {

    const {
        companies, states, companyTurn, listTaxRegime,
        method, handleInputChange, handlePickerValues,
        handleSelectValues, validaciones,
        id_company_turn, code, name, is_maquila,
        customer_since, send_results_pacient,
        category, is_block, consecutive_number,
        results_email, logo, microsite, username, imageLogo,
        payment_by_company, payment_by_patient,
        require_invoice, available_invoice_patient, credit_days,
        toggle, modal, modalTitle, loading,
        handleChangePaymentBy,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleChangeState,
        previewLogo, imageHandler,
        handleAddCompany,
        listCompanyBusinessNames, handleDinamicInputRFC,
        arrayMunicipality, removeAlterCompanies,
        totalPageCount, currentPage, nextPage, previousPage, goToPage, handleSearchCompany,
        //new micro
        is_requirements, requirements, on_check_req_especial, password_microsite, stamp_invoice,
        // ? SEND EMAIL
        handleSendEmail, modalEmail, toggleEmail, email, saveEmail, validacionesEmail, handleInputChangeWithPrefix,
        micrositeCode, generateRandomPassword, numberItems, closeModalCompanies, closeModalEmailCompanies,
        searchCompany,
        // handleClearFilter,

        //excel
        handleExportExcel, loadingExport,
        // * COMPANY BUSSINESS
        handleNewBussines, handleAddressInput, handleDeleteAddress,

        closeDialogMicrosite, handleCreateMicrosite, modalMicrosite, uploadImage,
        fileUploadRef, validateAndUpload, MAX_SIZE,
        listDays,
        handleViewCompany,
        modalviewHistoric, toggleHistoric, loadingHistoric, labelPatient, labeldataCustomer,


    } = useCompanies();

    let _microsite = localStorage.getItem('configuration_microsite');


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                {rowData.microsite && (
                    <button
                        type="button"
                        onClick={() => handleSendEmail(rowData.id_company)}
                        style={{
                            padding: "2px",
                            fontSize: "1rem",
                            height: "26px",
                            width: "26px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#ffb900",
                            border: "none",
                            color: "#fff"
                        }}
                        title="Enviar a correo"
                    >
                        <i className="icofont icofont-envelope" />
                    </button>
                )}

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_company)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_company)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>


                <button
                    type="button"
                    onClick={() => handleViewCompany(rowData.id_company, rowData.name)}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#074770",
                        border: "none",
                        borderRadius: "4px",
                        color: "#fff",
                        cursor: "pointer"
                    }}
                    title="Histórico de cambios"
                >
                    <i className="icofont icofont-history" />
                </button>
            </div>
        );
    };



    // * -----------------
    const [globalFilter, setGlobalFilter] = useState("");


    useEffect(() => {
        const savedFilter = localStorage.getItem('globalFilterCompany');
        if (savedFilter) {
            setGlobalFilter(savedFilter);
        }
    }, []);

    useEffect(() => {
        if (globalFilter) {
            localStorage.setItem('globalFilterCompany', globalFilter);
        } else {
            localStorage.removeItem('globalFilterCompany');
        }
    }, [globalFilter]);


    const handleClearFilter = () => {
        setGlobalFilter("");
    };


    const filterData = (data, filter) => {

        return data.filter(row => {

            const name_company = row?.name ?? "-----";
            const contract_number = row?.contract_number ?? "-----";
            const financing_method_name = row?.financing_method_name ?? "-----";
            const validity = row?.validity ?? "-----";
            const agreement_mode = row?.agreement_mode ?? "-----";
            const lowerCaseFilter = filter.toLowerCase();

            return (
                name_company.toLowerCase().includes(lowerCaseFilter) ||
                contract_number.toLowerCase().includes(lowerCaseFilter) ||
                financing_method_name.toLowerCase().includes(lowerCaseFilter) ||
                validity.toLowerCase().includes(lowerCaseFilter) ||
                agreement_mode.toLowerCase().includes(lowerCaseFilter)
            );
        });
    };





    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody className="p-1">
                                <div className="table-responsive">
                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                        <TitleDataTable
                                            titleTable={CompaniesList}
                                            buttonActions={handleExportExcel}
                                            titleButton="Descargar listado de clientes"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear Cliente"
                                            buttonActionsCreate={handleCreate}
                                            {...(_microsite === "True" && {
                                                microsite: true,
                                                titleButtonMicrosite: "Imagen para micrositio (Login)",
                                                buttonMicrosite: handleCreateMicrosite
                                            })}
                                            actionInput={setGlobalFilter}
                                            valueFilter={globalFilter}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClearFilter}
                                        />
                                    </Col>

                                    <DataTable
                                        value={filterData(companies, globalFilter)}
                                        paginator
                                        rows={numberItems}
                                        first={(currentPage - 1) * numberItems}
                                        totalRecords={companies.length}
                                        onPage={(e) => goToPage(e.page + 1)}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        responsiveLayout="scroll"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="code" header="Código" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="rfc" header="RFC" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name_company_turn" header="Giro" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="label_category" header="Categoría" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="icon_block" header="Bloqueo" headerStyle={headerStyle} style={cellStyle} />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                                    </DataTable>

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

            <ModalCompany
                {
                ...{
                    modal, toggle, modalTitle, method, loading,
                    states, companyTurn, listTaxRegime,
                    handleInputChange, handlePickerValues, handleSelectValues, validaciones,
                    id_company_turn, code, name, is_maquila, customer_since,
                    send_results_pacient, results_email, logo,
                    is_block, consecutive_number, microsite,
                    username, payment_by_company, payment_by_patient,
                    require_invoice, available_invoice_patient, credit_days,
                    imageLogo, imageHandler,
                    saveCreate, saveUpdate, saveDelete,
                    handleChangePaymentBy,
                    handleChangeState,
                    previewLogo, category,
                    handleAddCompany,
                    listCompanyBusinessNames, handleDinamicInputRFC, removeAlterCompanies,
                    is_requirements, requirements, on_check_req_especial, password_microsite, stamp_invoice, handleInputChangeWithPrefix, micrositeCode,
                    generateRandomPassword, handleNewBussines, handleAddressInput, handleDeleteAddress, closeModalCompanies,
                    listDays
                }
                }
            />
            <ModalSendEmail
                {
                ...{ modalEmail, toggleEmail, email, handleInputChange, saveEmail, validacionesEmail, loading, closeModalEmailCompanies }
                }

            />

            <DialogImgMicrositeCompany
                {
                ...{ modalMicrosite, closeDialogMicrosite, uploadImage, fileUploadRef, validateAndUpload, MAX_SIZE }
                }

            />

            {
                // ? HISTORIC
            }
            <Dialog
                closable={false}
                visible={modalviewHistoric}
                onHide={toggleHistoric}
                modal
                dismissableMask={false}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className='pi pi-history' ></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Histórico de cambios

                                </div>
                            </div>
                        </div>
                    </div>
                }
                className="Global-dialog Global-blue Global-large"
                maskClassName="custom-total-mask"

                footer={
                    <Button
                        color="danger"
                        onClick={toggleHistoric}
                    >
                        Cerrar
                    </Button>
                }
            >
                <br />
                <div
                    style={{
                        background: "#00294012",
                        borderRadius: "12px",
                        padding: "16px",
                        marginBottom: "16px",
                        borderLeft: "5px solid #0f3d5e",
                        boxShadow: "0px 3px 12px rgba(0,0,0,.08)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >

                    <div>

                        <div
                            style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                color: "#0f3d5e"
                            }}
                        >
                            Historial de cambios del cliente
                        </div>

                        <div
                            style={{
                                fontSize: "12px",
                                color: "#6c757d"
                            }}
                        >
                            {labelPatient ?? "---"}
                        </div>

                    </div>

                    <div
                        style={{
                            background: "#e8f1f8",
                            color: "#0f3d5e",
                            padding: "8px 14px",
                            borderRadius: "25px",
                            fontSize: "12px",
                            fontWeight: "600"
                        }}
                    >
                        <i
                            className="pi pi-clock mr-2"
                        />
                        {labeldataCustomer?.length ?? 0} movimientos
                    </div>

                </div>

                <DataTable
                    value={labeldataCustomer}
                    paginator
                    rows={10}
                    stripedRows
                    showGridlines
                    className="p-datatable-sm shadow-sm"
                    rowsPerPageOptions={[10, 50, 100]}
                    responsiveLayout="scroll"
                    emptyMessage={
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "20%" }}
                                alt="Sin resultados"
                            />
                            <br />
                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "12px" }}>
                                No se encontraron resultados.
                            </p>
                        </div>
                    }
                    style={{ fontSize: "11px" }}

                >

                    <Column
                        field="create_at"
                        header="Fecha"
                        sortable
                        headerStyle={headerStyle}
                    />

                    <Column
                        field="method"
                        header="Acción"
                        headerStyle={headerStyle}

                        body={(rowData) => (

                            <span
                                style={{
                                    background:
                                        rowData.method === "ACTUALIZAR"
                                            ? "#E3F2FD"
                                            : "#E8F5E9",

                                    color:
                                        rowData.method === "ACTUALIZAR"
                                            ? "#1565C0"
                                            : "#2E7D32",

                                    padding: "6px 12px",
                                    borderRadius: "30px",
                                    fontSize: "11px",
                                    fontWeight: 600
                                }}
                            >
                                <i
                                    className={
                                        rowData.method === "ACTUALIZAR"
                                            ? "pi pi-pencil"
                                            : "pi pi-plus"
                                    }
                                    style={{
                                        marginRight: "5px"
                                    }}
                                />

                                {rowData.method}
                            </span>

                        )}
                    />

                    <Column
                        field="name_user"
                        header="Usuario"
                        headerStyle={headerStyle}

                    />

                    <Column
                        field="site"
                        header="Módulo"
                        headerStyle={headerStyle}

                    />

                    <Column
                        field="field_name"
                        header="Campo"
                        headerStyle={headerStyle}

                    />

                    <Column
                        field="original_information"
                        header="Anterior"
                        headerStyle={headerStyle}

                        body={(rowData) => (

                            <span
                                style={{
                                    color: "#6c757d"
                                }}
                            >
                                {rowData.original_information}
                            </span>

                        )}
                    />

                    <Column
                        field="updated_information"
                        header="Nuevo"
                        headerStyle={headerStyle}

                        body={(rowData) => (

                            <span
                                style={{
                                    color: "#1565C0",
                                    fontWeight: 600
                                }}
                            >
                                {rowData.updated_information}
                            </span>

                        )}
                    />

                </DataTable>

            </Dialog>


        </Fragment >
    )
}
